import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        //token:localStorage.getItem('token') || '',
        token: '',
        i18nLocale: 'zhHans',
        userInfo: {},
        //菜单条状态
        drawer: true,
        menuItems: [],
        permissionList:[],
    },
    mutations: {
        set_token(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        del_token(state) {
            state.token = ''
            localStorage.removeItem('token')
        },
        changeI18n(state, i18n) {
            state.i18nLocale = i18n
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
        },
        changeDrawerOff(state) {
            setTimeout(function () {
                state.drawer = false
            }, 500)
        },
        changeDrawerOn(state) {
            setTimeout(function () {
                state.drawer = true
            }, 500)
        },
        reverseDrawer(state) {
            state.drawer = !state.drawer
        },
        setMenuItems(state, items) {
            state.menuItems = items
        },
        setPermissionList(state,pl){
            state.permissionList = pl;
        }
    },
    getters: {
        getToken: (state) => {
            state.token = state.token || localStorage.getItem('token');
            return state.token
        },
        checkPermissions:(state)=>(competence)=>{
            let flag = false;
            if(state.permissionList) {
                for (let obj of state.permissionList) {
                    if (obj == competence) {
                        flag = true;
                    }
                }
            }
            return flag;
        }
    }
});

export default store;
